module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-37.a7199d9f.svg";